import apiService from './api';

const invoiceService = {
  list(params = {}) {
    return apiService.get('/invoices', { params });
  },

  getSummary(params = {}) {
    return apiService.get('/invoices/summary', { params });
  },

  getById(id) {
    return apiService.get(`/invoices/${id}`);
  },

  exportList(params = {}) {
    return apiService.get('/invoices/export', { params });
  }
};

export default invoiceService;
